'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _messageHeader = require('../message-header');

var _messageHeader2 = _interopRequireDefault(_messageHeader);

var _messageTime = require('../message-time');

var _messageTime2 = _interopRequireDefault(_messageTime);

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  avatar: _propTypes2.default.string,
  createdAt: _propTypes2.default.string.isRequired,
  username: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['text', 'image', 'sticker', 'giphy', 'video']),
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageHeaderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageBodyStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageTimeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  myMessage: _propTypes2.default.bool,
  compact: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  badge: _propTypes2.default.node,
  iconMenu: _propTypes2.default.node,
  video: _propTypes2.default.node.isRequired,
  collapsed: _propTypes2.default.bool,
  collapsedText: _propTypes2.default.node.isRequired
};

var defaultProps = {
  avatar: '',
  type: 'text',
  style: {},
  messageHeaderStyle: {},
  messageBodyStyle: {},
  messageTimeStyle: {},
  fontSize: 'small',
  myMessage: false,
  compact: false,
  color: '',
  badge: null,
  iconMenu: null,
  collapsed: false
};

var VideoMessage = function VideoMessage(_ref) {
  var color = _ref.color,
      myMessage = _ref.myMessage,
      avatar = _ref.avatar,
      compact = _ref.compact,
      style = _ref.style,
      fontSize = _ref.fontSize,
      messageHeaderStyle = _ref.messageHeaderStyle,
      createdAt = _ref.createdAt,
      username = _ref.username,
      type = _ref.type,
      messageBodyStyle = _ref.messageBodyStyle,
      messageTimeStyle = _ref.messageTimeStyle,
      badge = _ref.badge,
      iconMenu = _ref.iconMenu,
      video = _ref.video,
      collapsed = _ref.collapsed,
      collapsedText = _ref.collapsedText;

  var headerStyle = (0, _combineStyles2.default)(messageHeaderStyle, { marginBottom: '9px' });

  return _react2.default.createElement(
    'div',
    { style: _getStyles2.default.root(color, myMessage, avatar, compact, collapsed, iconMenu, style) },
    _react2.default.createElement(_messageHeader2.default, {
      avatar: avatar,
      compact: compact,
      myMessage: myMessage,
      fontSize: fontSize,
      headerStyle: headerStyle,
      username: username,
      badge: badge,
      iconMenu: !(0, _isEmpty2.default)(iconMenu)
    }),
    _react2.default.createElement(
      'p',
      { style: _getStyles2.default.body(myMessage, fontSize, collapsed, messageBodyStyle) },
      !collapsed ? video : _react2.default.createElement(
        'span',
        null,
        collapsedText
      ),
      _react2.default.createElement(_messageTime2.default, {
        myMessage: myMessage,
        type: type,
        style: messageTimeStyle,
        createdAt: createdAt,
        fontSize: fontSize,
        collapsed: collapsed
      })
    ),
    iconMenu ? _react2.default.createElement(
      'div',
      { style: _styles2.default.iconMenu },
      iconMenu
    ) : null
  );
};

VideoMessage.propTypes = propTypes;
VideoMessage.defaultProps = defaultProps;

exports.default = VideoMessage;
module.exports = exports.default;